import React from 'react'
import styled, { css } from 'styled-components'
import colors from '../../../vars/colors'
import breakpoints from '../../../vars/breakpoints'
import gutters from '../../../vars/gutters'

export const HeroUILayout = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    .bumpometer {
        overflow: hidden;
        position: absolute;
        bottom: 20px;
        left: 50px;
        transition: transform 400ms ease-in-out;
        transition-delay: 150ms;
        transform: ${props => props.interaction ? 'translate3d(0,0,0)' : 'translate3d(-200%, 0, 0)'};
        @media (max-width: ${breakpoints['bp-mobile']}) {
            top: 0px;
            left: 0px;
            bottom: auto;
            transform-origin: center;
            transform: ${props => props.interaction ? 'translate3d(0,0,0) scale(0.6)' : 'translate3d(-200%, 0, 0) scale(0.6)'};
        }
        .bumpometerCopy {
            font-family: 'OneDotExt', sans-serif;
            color: white;
            font-size: 13px;
            width: 100px;
            text-transform: uppercase;
            line-height: 1.38;
            margin-bottom: -30px;
            @media (max-width: ${breakpoints['bp-mobile']}) {
                display: none;
            }
        }
        svg {
            width: 150px;
            height: 100px;
        }
    }
    .pizzaMessWrapper {
        position: absolute;
        right: 30px;
        bottom: 20px;
        text-align: right;
        transition: transform 400ms ease-in-out;
        transition-delay: 300ms;
        transform: ${props => props.interaction ? 'translate3d(0,0,0)' : 'translate3d(200%, 0, 0)'};
        .pizzamessCopy {
            font-family: 'OneDotExt', sans-serif;
            color: white;
            font-size: 13px;
            width: 100px;
            text-transform: uppercase;
            line-height: 1.38;
            margin-bottom: -10px;
            @media (max-width: ${breakpoints['bp-mobile']}) {
                display: none;
            }
        }
        .pizzamess {
            display: inline-block;
            svg {
                transform-origin: center center;
                transform: scale(1.1);
            }
        }
        @media (max-width: ${breakpoints['bp-mobile']}) {
            display: none;
        }
    }
    .controlsWrapper {
        width: 300px;
        position: absolute;
        transition: all 400ms ease-in-out;
        bottom: ${props => props.interaction ? '-10px' : 'calc(100% * (1/12) - 10px)'};
        left: calc(50% - 150px);
        right: calc(50% - 150px);
        transform: ${props => props.controls ? 'scale(1)' : 'scale(0)'};
        @media (max-width: ${breakpoints['bp-tablet']}) {
            width: 200px;
            left: calc(50% - 100px);
            right: calc(50% - 100px);
        }
        @media (max-width: ${breakpoints['bp-mobile']}) {
            width: 230px;
            left: calc(50% - 115px);
            right: calc(50% - 115px);
        }
        .stageKnob {
            cursor: pointer;
            transition: all 300ms ease-out;
            &:hover {
                stroke-width: 8px;
                fill: #E4334B;
            }
        }
        path.redStroke {
            stroke-dasharray: 100;
            stroke-dashoffset:100;
            transition-property: stroke-dashoffset;
            transition-timing-function: linear;
            &.active {
                stroke-dashoffset: 0;
            }
        }
        &.mobile {
            bottom: ${props => props.interaction ? '-35px' : 'calc(100% * (1/12) - 35px)'};
            path.redStroke {
            stroke-dasharray: 90;
            stroke-dashoffset: 90;
            transition-property: stroke-dashoffset;
            transition-timing-function: linear;
                &.active {
                    stroke-dashoffset: 0;
                }
            }
            .label {
                opacity: 0;
                transition: opacity 300ms ease-in-out;
                transform: translate(-50%, 0);
                &.active {
                    opacity: 1;
                }
                &.one {
                    transition-delay: 0ms;
                    bottom: 85px;
                    left: ${(props) => props.lang.match(/^en/) ? '17px' : '22px'};
                }
                &.two {
                    transition-delay: 0ms;
                    bottom: 85px;
                    left: 84px;
                }
                &.three {
                    transition-delay: 0ms;
                    bottom: 85px;
                    left: 151px;
                }
                &.four {
                    transition-delay: 0ms;
                    bottom: 85px;
                    left: 218px;
                }
            }
        }
        .label {
            position: absolute;
            font-family: 'OneDotCd', sans-serif;
            font-size: 18px;
            text-transform: uppercase;
            /* font-weight: bold; */
            color: white;
            transition: all 300ms ease-in-out;
            transform: ${props => props.controls ? 'translate3d(0, 0, 0)' : 'translate3d(0, -15px, 0)'};
            opacity: ${props => props.controls ? '1' : '0'};
            letter-spacing: 1px;
            &.one {
                transition-delay: 420ms;
                left: ${(props) => props.lang.match(/^en/) ? '-30px' : '-48px'};
                bottom: 72px;
                @media (max-width: ${breakpoints['bp-tablet']}) {
                    bottom: 50px;
                }
            }
            &.two {
                transition-delay: 520ms;
                left: ${(props) => props.lang.match(/^en/) ? '4x' : '0'};
                bottom: 145px;
                @media (max-width: ${breakpoints['bp-tablet']}) {
                    left: -16px;
                    bottom: 100px;
                }
            }
            &.three {
                transition-delay: 620ms;
                left: 223px;
                bottom: 145px;
                @media (max-width: ${breakpoints['bp-tablet']}) {
                    left: 145px;
                    bottom: 100px;
                }
            }
            &.four {
                transition-delay: 720ms;
                left: 295px;
                bottom: 72px;
                @media (max-width: ${breakpoints['bp-tablet']}) {
                    left: 195px;
                    bottom: 50px;
                }
            }
        }
    }
    .timeStampWrapper {
        position: absolute;
        top: 50px;
        transition: transform 400ms ease-in-out;
        transition-delay: 500ms;
        transform: ${props => props.interaction ? 'translate3d(0,0,0) scale(1)' : 'translate3d(0, -300%, 0) scale(0.1)'};
        &.left {
            left: 50px;
        }
        &.right {
            right: 50px;
        }
    }
    .timeStamp {
        padding: 8px;
        text-transform: uppercase;
        color: white;
        font-size: 13px;
        font-family: 'OneDotExt', sans-serif;
        font-weight: bold;
        position: relative;
        .corner {
            position: absolute;
            width: 6px;
            height: 6px;
            border-color: white;
            border-width: 2px;
            border-style: solid;
            &.bottomLeft {
                left: 0;
                bottom: 0;
                border-right: none;
                border-top: none;
            }
            &.bottomRight {
                right: 0;
                bottom: 0;
                border-left: none;
                border-top: none;
            }
            &.topLeft {
                left: 0;
                top: 0;
                border-bottom: none;
                border-right: none;
            }
            &.topRight {
                right: 0;
                top: 0;
                border-bottom: none;
                border-left: none;
            }
        }
    }
    .controlLabel {
        font-family: 'OneDotExt', sans-serif;
        font-size: 16px;
        line-height: 1.13;
        letter-spacing: 1.8px;
        text-align: center;
        position: absolute;
        bottom: 40px;
        width: 150px;
        left: calc(50% - 75px);
        right: calc(50% - 75px);
        text-transform: uppercase;
        color: white;
        transition: all 400ms ease-in-out;
        transform: ${props => props.controls ? 'scale(1)' : 'scale(0)'};
        bottom: ${props => props.interaction ? '40px' : 'calc(100% * (1/12) + 40px)'};
        @media (max-width: ${breakpoints['bp-tablet']}) {
            bottom: ${props => props.interaction ? '20px' : 'calc(100% * (1/12) + 20px)'};
            font-size: 14px;
        }
        @media (max-width: ${breakpoints['bp-mobile']}) {
            display: none;
        }
    }
`

export const FakeZoomer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    overflow: hidden;
    pointer-events: none;
    .top,
    .bottom,
    .left,
    .right {
        transition: transform 400ms ease-in-out;
        position: absolute;
        background: white;
    }
    .top,
    .bottom {
        left: 0;
        right: 0;
        height: calc(100% * (1/12));
    }
    .top {
        top: calc(-100% * (1/11));
        transform: translate3d(0, 100%, 0);
    }
    .bottom {
        bottom: calc(-100% * (1/12));
        transform: translate3d(0, -100%, 0);
    }
    .left,
    .right {
        width: calc(100% * (1/12));
        top: 0;
        bottom: 0;
    }
    .left {
        left: calc(-100% * (1/12));
        transform: translate3d(100%, 0, 0);
    }
    .right {
        right: calc(-100% * (1/12));
        transform: translate3d(-100%, 0, 0);
    }
    &.zoomed {
        .top,
        .bottom,
        .left,
        .right {
            transform: translate3d(0, 0, 0);
        }
    }
`

export const LoadingWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    overflow: hidden;
    pointer-events: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.5);
    opacity: 0;
    animation: loadEaseIn 1s forwards;
    animation-delay: 500ms;
    @keyframes loadEaseIn {
        0% {opacity: 0 }
        100% {opacity: 1 }
    }
    .pizzaHolder {
        width: 100px;
        height: 100px;
        transform-origin: center center;
        animation: pizzaAnimation 2s infinite;
        animation-timing-function: linear;
        @keyframes pizzaAnimation {
            0% {transform: rotate(0deg) }
            100% {transform: rotate(360deg) }
        }
    }
    .loading {
        font-family: 'OneDotCd', sans-serif;
        font-weight: bold;
        text-transform: uppercase;
        margin-top: 10px;
        margin-left: 11px;
    }
`

export const HeroHeaderCopy = styled.div`
    pointer-events: none;
    position: absolute;
    width: 40%;
    z-index: 5;
    top: 2px;
    transition: all 400ms ease-in-out;
    opacity: ${props => props.in ? '1' : '0'};
    transform: ${props => props.in ? 'translate3d(0,0,0)' : 'translate3d(0,40px,0)'};
    @media (max-width: ${breakpoints['bp-tablet']}) {
        width: 66%;
    }
`

export const HeroStamp = styled.div`
    pointer-events: none;
    position: absolute;
    top: 55%;
    @media (max-width: ${breakpoints['bp-desktop']}) {
        top: ${props => props.lang === 'en' ? '35%' : '30%'};
    }
    left: calc(85% - 250px);
    font-family: 'OneDotExt', sans-serif;
    width: 250px;
    color: white;
    font-size: 19px;
    line-height: 1;
    text-align: center;
    padding: 10px;
    border: solid 6px white;
    box-sizing: border-box;
    text-transform: uppercase;
    transform-origin: center;
    transform: rotate(25deg);
    transition: all 400ms ease-in-out;
    opacity: ${props => props.in ? '1' : '0'};
    transform: ${props => props.in ? 'rotate(25deg)' : 'rotate(-10deg)'};
    @media (max-width: ${breakpoints['bp-mobile']}) {
        font-size: 10px;
        width: 180px;
        transform: ${props => props.in ? 'rotate(-10deg)' : 'rotate(-25deg)'};
        top: 50%;
        left: 20%;
    }
`

export const LangToggles = styled.div`
    margin-bottom: 20px;
    margin-top: 70px;
    position: relative;
    text-align: right;
    z-index: 5;
    @media (min-width: ${breakpoints['bp-mobile']}) {
        margin-right: 1rem;
        margin-top: 90px;
    }
    p {
        display: inline-block;
        font: 400 13.3333px Arial;
        font-size: 12px;
        margin-right: 10px;
    }
    button {
        background-color: transparent;
        border: none;
        color: ${colors['lipstick']};
        margin-right: 16px;
        outline: none;
        padding: 0;

        &:hover,
        &:focus {
            text-decoration: underline;
        }
    }
`



// WEBPACK FOOTER //
// ./src/components/modules/HomeHero/styled-components.js